export default __webpack_public_path__ + "static/patient-guide--cervical-cancer-c42fb014c7b98443cf12c52f69925ae3.png";